import html from "./html";

const delayLoadRecaptcha = () => {
  const { ibis } = window;

  const seconds = 5;

  const googleRecaptchaGlobals = document.createElement("script");
  googleRecaptchaGlobals.innerHTML = `var wpcf7_recaptcha = {'sitekey':'${recaptcha_key}','actions':{'homepage':'homepage','contactform':'contactform'}};`;

  document.body.appendChild(googleRecaptchaGlobals);

  function loadRecaptcha() {
    const googleRecaptchaJs = document.createElement("script");
    googleRecaptchaJs.id = "google-recaptcha-js";
    document.body.appendChild(googleRecaptchaJs);
    googleRecaptchaJs.src = `https://www.google.com/recaptcha/api.js?render=${recaptcha_key}&#038;ver=3.0`;

    setTimeout(() => {
      const wpcf7RecaptchaJs = document.createElement("script");
      wpcf7RecaptchaJs.id = "wpcf7-recaptcha-js";
      document.body.appendChild(wpcf7RecaptchaJs);
      const homeUrl = home_url.replace("/en/", "");
      wpcf7RecaptchaJs.src = `${homeUrl}/wp-content/themes/Ibis/src/js/wpcf7-init-recaptcha.js`;
    }, 3000);
  }

  setTimeout(() => {
    loadRecaptcha();
  }, seconds * 1000);
};

export default delayLoadRecaptcha;
